<template>
  <div>
    <app-filter
      :filter-list="table_filter"
      @search="search"
    />
    <div class="text-right">
      <el-button size="mini" type="success" @click="onPull">同步</el-button>
    </div>
    <app-table
      ref="app-table"
      class="mt-20"
      :table-key="table_key"
      :tablep="table_params"
      :table-props="{'max-height': '450px'}"
      :get-data="getMicroGameList"
    />
  </div>
</template>

<script>
import { getMicroGameListApi, pullMicroGameListApi } from '@/api/tool/micro-game/jrtt';

export default {
  components: {
    'app-filter': () => import('@/components/app-filter'),
    'app-table': () => import('@/components/app-table'),
  },
  props: {
    /** 广告主ID */
    advertiserId: {
      type: [String, Number],
      required: true,
    },
    /** 小程序资产id */
    microAppInstanceId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      table_filter: require('./model/table-filter.js')(this),
      table_key: require('./model/table-key.js')(this),
      table_params: {
        page: 1,
        limit: 10,
      },
    };
  },
  methods: {
    /**
     * 搜索模板
     * @param {Object} params 搜索参数
     */
    search(params) {
      Object.assign(this.table_params, params);
      this.$refs['app-table'].seekTable();
    },
    /**
     * 获取字节小游戏列表
     * @param {Object} parmas 接口参数
     */
    getMicroGameList(params) {
      return new Promise((resolve, reject) => {
        getMicroGameListApi({
          advertiser_id: this.advertiserId,
          micro_app_instance_id: this.microAppInstanceId,
          ...params,
        }).then(resolve).catch(reject);
      });
    },
    /**
     * 同步字节小游戏列表接口
     * @param {Object} parmas 接口参数
     */
    pullMicroGameList(params) {
      return new Promise((resolve, reject) => {
        pullMicroGameListApi(params).then(resolve).catch(reject);
      });
    },
    /** 同步 */
    onPull() {
      const params = {
        advertiser_id: this.advertiserId,
        micro_app_instance_id: this.microAppInstanceId,
      };
      this.pullMicroGameList(params).then(res => {
        this.$message.success(res.message || '同步成功');
        this.$refs['app-table'].seekTable();
      });
    },
    /**
     * 确认
     * @param {Object} row 字节小游戏数据
     */
    confirm(row) {
      this.$emit('confirm', row);
    },
  },
};
</script>
